export default __webpack_public_path__ + "static/media/flisekompaniet-logo.bfad5b49.png";